"use client"

import {
  Popover,
  PopoverPanel,
  Transition,
  PopoverButton,
} from "@headlessui/react"
import { BarsThree, XMark } from "@medusajs/icons"
import { Link } from "@i18n/navigation"
import { useTranslations } from "next-intl"
import { Fragment } from "react"

const sideMenuItems = [
  { key: "home" as const, href: "/" },
  { key: "preview" as const, href: "/#preview" },
  { key: "features" as const, href: "/#features" },
  { key: "pricing" as const, href: "/#pricing" },
  { key: "faq" as const, href: "/#faq" },
  { key: "changelog" as const, href: "/changelog" },
  { key: "account" as const, href: "/account" },
]

const SideMenu = () => {
  const t = useTranslations("SideMenu")

  return (
    <div className="h-full">
      <Popover className="h-full flex">
        {({ open, close }) => (
          <>
            <div className="relative flex h-full">
              <PopoverButton
                aria-label={t("menuButton")}
                data-testid="nav-menu-button"
                className="relative h-full flex gap-1 items-center text-ui-fg-subtle hover:text-ui-fg-base transition-colors"
              >
                <BarsThree />
              </PopoverButton>
            </div>

            {open && (
              <div
                className="fixed inset-0 z-[50] bg-black/40"
                onClick={close}
                data-testid="side-menu-backdrop"
              />
            )}

            <Transition
              show={open}
              as={Fragment}
              enter="transition ease-out duration-150"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <PopoverPanel className="flex flex-col fixed inset-y-0 start-0 w-64 z-[51] border-e border-ui-border-base bg-ui-bg-base">
                <div className="flex justify-end p-4">
                  <button
                    data-testid="close-menu-button"
                    aria-label={t("close")}
                    onClick={close}
                    className="text-ui-fg-subtle hover:text-ui-fg-base"
                  >
                    <XMark />
                  </button>
                </div>
                <ul className="flex flex-col gap-6 items-start px-6">
                  {sideMenuItems.map(({ key, href }) => (
                    <li key={key}>
                      <Link
                        href={href}
                        className="text-xl hover:text-ui-fg-subtle transition-colors"
                        onClick={close}
                        data-testid={`${key}-link`}
                      >
                        {t(`items.${key}`)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </PopoverPanel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  )
}

export default SideMenu
